import request from '@/router/axios';

export const getMyList = (current, size, params) => {
  return request({
    url: '/api/blade-desk/jobinformation/myPage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-desk/jobinformation/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getAuList = (current, size, params) => {
  return request({
    url: '/api/blade-desk/jobinformation/auditPage',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-desk/jobinformation/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-desk/jobinformation/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-desk/jobinformation/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-desk/jobinformation/submit',
    method: 'post',
    data: row
  })
}

export const audit = (row) => {
  return request({
    url: '/api/blade-desk/jobinformation/audit',
    method: 'post',
    data: row
  })
}

